import React from 'react'
import { useEffect } from 'react';
import { Pagination } from '../../../common/pagination/pagination';
import { Footer } from '../../../common/footer/footer';

import AOS from 'aos';
import 'aos/dist/aos.css';

import { ModulePermission } from '../../../../shared/helper'
import Sidebar from "../sidebar/sidebar.js";

export const CustomerAskTheExpertJsx = (props) => {
  
  const {
    categoryData,    
    formData,
    onInputChange,
    onTouchHandler,
    onSubmitButtonClick,
    onPaginationButtonClick,
    expertData, checkedItems,
    handleChange,
    deleteOffer, editCategory, meta, permissions, editOn,
    toggleNewPermissionInput,
    showNewPermissionInput,
    newPermission,
    handleNewPermissionSubmit,
  } = props;
  useEffect(() => {
    AOS.init();
    window.scrollTo(0, 0);
  }, [])


  return (
    <>
      <section className="entiredashboard admindashboard">
        <div className="container">

          <div className="row">
            <div className="col-lg-3 col-sm-3">


              <div className="dashboardleftpanel martop40">

                <div className="dashboardlink martop40">
                  <Sidebar />
                </div>
              </div>
            </div>
            <div className="col-lg-9 col-sm-9">
              <div className="dashboardrightpanel martop40">
                <h2 className="h2_style">Submit Modules</h2>

                <div className="myexpertformarea searcharea seachadmincustom martop40">
                  <div className="input-container form-group">

                    <input
                      className="input form-control"
                      placeholder=" "
                      name="name"
                      onChange={onInputChange}
                      onBlur={onTouchHandler}
                      value={formData.name}
                    />
                    <div className="placeholder">Name *</div>

                  </div>
                  {permissions?.map(role => {
                    const isChecked = checkedItems.some(item => item.name === role.name);
                    return (
                      <div key={role.name}>
                        <input
                          disabled={!formData.name}
                          type="checkbox"
                          id={role.name}
                          name={role.name}
                          value={role.name}
                          checked={isChecked}
                          onChange={(e) => handleChange({ "modulePermissionId": role.name }, e.target.checked)}
                        />
                        <label htmlFor={role.name}> {role.name}</label>
                      </div>
                    );
                  })}
                  {/* Add New Permission Button */}
                  <button className="input-container form-group" disabled={!formData.name} onClick={toggleNewPermissionInput}> Add New Permission</button>

                  {/* Input Box for New Permission */}
                  {showNewPermissionInput && (
                    <div className="input-container form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Permission Name"
                        value={newPermission}
                        name="newPermission"
                        onChange={onInputChange}
                      />
                      <button
                        type="button"
                        className="ctaonebutton"
                        onClick={handleNewPermissionSubmit}
                      >
                        Submit New Permission
                                            </button>
                    </div>
                  )}




                  <div className="input-container form-group"><button disabled={!formData.name}
                    type="submit" className="ctaonebutton" onClick={() => onSubmitButtonClick()}>Submit</button></div>
                </div>
              </div>
              {!editOn &&
                <div className="expertsection martop30 mb-5">
                  <div className="searchdetails searchdetalsen">
                    <table className="searchdetailsdb">
                      <tr>
                        <th>Name</th>
                        <th>Action</th>
                        <th>Action</th>
                      </tr>

                      {categoryData?.map((item, i) => (
                        <>
                          <tr>
                            <td>{item.moduleName}</td>

                            {/* <td>{moment(item.updatedAt).format('MM-DD-YYYY')}</td> */}
                            <td>
                              <button disabled={!ModulePermission().canCreateCategory} className="btn btn-success" onClick={() => editCategory(item?.institutionCategoryId)}>Edit</button>
                              </td><td>
                              <button disabled={!ModulePermission().canCreateCategory} className="btn btn-danger" onClick={() => deleteOffer(item?.institutionCategoryId)} >Delete</button></td>

                          </tr>
                        </>
                      ))}

                    </table>
                  </div>
                </div>
              }

              {expertData?.length > 0 && !editOn && <Pagination
                limit={10}
                totalCount={meta?.totalCount}
                onPaginationButtonClick={onPaginationButtonClick}
              />}
            </div>

          </div>

        </div>

      </section>

      <Footer />
    </>

  );
};

export default CustomerAskTheExpertJsx;